import MachinesTopSection from '../../components/machines/MachinesTopSection';
import MachineControlCard from '../../components/machines/control/MachineControlCard';
import { machines } from '../../data/machine/machines';
import useAdvanceTable from '../../hooks/useAdvanceTable';
import AdvanceTableProvider from '../../providers/AdvanceTableProvider';
import { Col, Row } from 'react-bootstrap';
import MachineListTable from './MachineListTable';
import { MachineListTableColumns } from './MachineListTable';
import { MachineDataContext } from '../../providers/MachineDataContext';
import { WebSocketContext } from '../../providers/WebSocketProvider';
import { useContext, useEffect, useMemo, memo } from 'react';
import { Bars } from 'react-loader-spinner';
import { useAppContext } from '../../providers/AppProvider';

export const columns = [
  {
    // For filtering and searching projects by status
    id: 'status',
    accessorFn: ({ status }) => status?.label || 'UNKNOWN'
  },
  {
    // For searching projects by name
    accessorKey: 'name'
  }
];

const MachineTracking = () => {
  const { machineData, subscribeToChannel, unsubscribeToChannel } =
    useContext(WebSocketContext);

  const table = useAdvanceTable({
    data: machineData.state || [],
    columns: MachineListTableColumns,
    pageSize: 10,
    pagination: true,
    sortable: true
  });

  console.log('Machine Data in Machine Tracking Page: REPAINTED');

  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  useEffect(() => {
    subscribeToChannel('machine-all');

    return () => {
      unsubscribeToChannel();
    };
  }, []);

  if (!machineData.state.length || !Array.isArray(machineData.state)) {
    // Render a loading state or a fallback if data is not available yet
    return (
      <Bars
        height="80"
        width="80"
        radius="9"
        color={theme === 'dark' ? 'white' : '#3874ff'}
        ariaLabel="three-dots-loading"
        wrapperStyle={styles.spinnerContainer}
      />
    );
  }

  return (
    <div>
      <AdvanceTableProvider {...table}>
        <div className="d-flex flex-wrap mb-4 gap-3 gap-sm-6 align-items-center">
          <h2 className="mb-0">
            <span className="me-3">Machines tracking</span>{' '}
          </h2>
          <h3 className="mb-0 ms-auto">
            <span className="me-3">
              Shift : {machineData.currentShift}
            </span>{' '}
          </h3>
        </div>
        <MachinesTopSection activeView="list" />
        <MachineListTable />
      </AdvanceTableProvider>
    </div>
  );
};

const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Add a background with some opacity
    zIndex: 1000 // Ensure the spinner is on top
    // backgroundColor: '#000', // Optional: background color
  }
};

export default MachineTracking;
